export const VENDORS = {
  VENDORS_TOTAL_BY_PAGE: '20',
};
